/* v2 : filets clavier au niveau document (21/08). */
/*
  Comportements de la fiche produit (section main-product.liquid), portés
  depuis le custom code de page Webflow (cf. _ref/SPEC-PRODUIT.md, partie 3) :
  - sélection d'une valeur d'option (taille, saveur...) -> changement de
    variante (input caché, prix affiché, URL ?variant=, état visuel
    size-option-active), indication de stock et prix "à partir de" (aucune
    valeur présélectionnée si les prix varient) ; l'option travaillée est
    générique, product.js ne connaît pas son nom, seulement ses valeurs ;
  - stepper de quantité (min 1, entier) ;
  - ajout au panier : délégué au tiroir OdaCart quand il est chargé, sinon
    soumission native du formulaire vers /cart/add (secours sans JS) ;
  - pop-up "Guide des tailles" (croix / overlay / Échap, verrou de scroll) ;
  - lightbox de la galerie (3 photos affichées, navigation sur tous les
    médias, miniatures, clavier, préchargement).
  Aucune dépendance externe.
*/
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Utilitaires communs (focus piégé dans une fenêtre modale) ---------------
  ------------------------------------------------------------------------ */

  var FOCUSABLE_SELECTOR = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function focusablesIn(container) {
    return [].slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab') return;
    var list = focusablesIn(container);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === container)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ------------------------------------------------------------------------
     Buy-box : taille -> variante, quantité, ajout au panier, stock ---------
  ------------------------------------------------------------------------ */

  function parseVariants(box) {
    var dataEl = box.querySelector('[data-product-variants]');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function findVariantByValue(variants, value) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].optionValue === value) return variants[i];
    }
    return null;
  }

  function initBuyBox(box) {
    if (!box || box.dataset.odaProductBound === '1') return;
    box.dataset.odaProductBound = '1';

    var form = box.querySelector('.product-form');
    if (!form) return;

    var variants = parseVariants(box);
    var variantInput = form.querySelector('[data-variant-input]');
    var priceEl = box.parentElement && box.parentElement.querySelector('[data-hero-price]');
    var priceLabelEl = box.parentElement && box.parentElement.querySelector('[data-hero-price-label]');
    var sizeButtons = [].slice.call(box.querySelectorAll('[data-size-option]'));
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonText = addButton ? addButton.querySelector('[data-add-to-cart-text]') : null;
    var stockRow = box.querySelector('[data-stock-indicator]');
    var stockDot = box.querySelector('[data-stock-dot]');
    var stockText = box.querySelector('[data-stock-text]');

    var addLabel = box.getAttribute('data-label-add-to-cart') || 'Ajouter au panier';
    var soldOutLabel = box.getAttribute('data-label-sold-out') || 'Épuisé';
    var thresholdOrange = parseInt(box.getAttribute('data-stock-threshold-orange'), 10) || 10;
    var thresholdRed = parseInt(box.getAttribute('data-stock-threshold-red'), 10) || 2;

    /* --- Indication de stock ------------------------------------------------
       Rejoue la même logique que le rendu serveur (main-product.liquid) à
       chaque changement de taille : point coloré + texte, épuisé prioritaire
       sur le comptage (gère le cas "vente continue" où qty peut être à 0
       alors que la variante reste commandable). */
    function renderStock(variant) {
      if (!stockRow || !stockDot || !stockText) return;
      if (!variant) {
        stockRow.classList.add('is-hidden');
        return;
      }
      stockRow.classList.remove('is-hidden');
      stockDot.className = 'stock-dot';

      if (!variant.available) {
        stockDot.classList.add('stock-dot-out');
        stockText.textContent = soldOutLabel;
        return;
      }
      if (!variant.managed) {
        stockDot.classList.add('stock-dot-green');
        stockText.textContent = 'En stock';
        return;
      }

      var qty = typeof variant.qty === 'number' ? variant.qty : 0;
      /* Vente continue : commandable avec un stock à 0 voire négatif. On ne
         compte plus, sinon on affichait « il ne reste que 0 exemplaires ».
         Même règle que le rendu serveur (main-product.liquid). */
      if (qty <= 0) {
        stockDot.classList.add('stock-dot-green');
        stockText.textContent = 'En stock';
        return;
      }
      if (qty <= thresholdRed) {
        stockDot.classList.add('stock-dot-red');
        stockText.textContent = qty === 1
          ? 'Dépêchez-vous, il ne reste qu’un exemplaire'
          : 'Dépêchez-vous, il ne reste que ' + qty + ' exemplaires';
      } else if (qty <= thresholdOrange) {
        stockDot.classList.add('stock-dot-orange');
        stockText.textContent = 'Plus que ' + qty + ' en stock';
      } else {
        stockDot.classList.add('stock-dot-green');
        stockText.textContent = 'En stock';
      }
    }

    /* --- Sélection de taille -> variante ----------------------------------- */

    function applyVariant(variant, updateHistory) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceEl && variant.price) priceEl.textContent = variant.price;
      /* Une taille précise est choisie : le prix n'est plus "à partir de". */
      if (priceLabelEl) priceLabelEl.classList.add('is-hidden');

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.classList.toggle('is-disabled', !variant.available);
      }
      if (addButtonText) {
        addButtonText.textContent = variant.available ? addLabel : soldOutLabel;
      }

      renderStock(variant);

      if (updateHistory && window.history && window.history.replaceState && window.URL) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, document.title, url);
      }
    }

    function selectSize(button, updateHistory) {
      var value = button.getAttribute('data-value');
      var variant = findVariantByValue(variants, value);
      if (!variant) return;

      sizeButtons.forEach(function (b) {
        b.classList.remove('size-option-active');
        b.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('size-option-active');
      button.setAttribute('aria-pressed', 'true');

      applyVariant(variant, updateHistory);
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectSize(button, true);
      });
    });

    /* --- Quantité (min 1, entier) ------------------------------------------- */

    var qtyMinus = box.querySelector('[data-qty-minus]');
    var qtyPlus = box.querySelector('[data-qty-plus]');
    var qtyDisplay = box.querySelector('[data-qty-display]');
    var qtyInput = box.querySelector('[data-qty-input]');

    if (qtyMinus && qtyPlus && qtyDisplay) {
      var qty = parseInt(qtyInput ? qtyInput.value : qtyDisplay.textContent, 10);
      if (!qty || qty < 1) qty = 1;

      var renderQty = function () {
        qtyDisplay.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      };
      renderQty();

      qtyMinus.addEventListener('click', function () {
        if (qty > 1) {
          qty -= 1;
          renderQty();
        }
      });
      qtyPlus.addEventListener('click', function () {
        qty += 1;
        renderQty();
      });
    }

    /* --- Ajout au panier ----------------------------------------------------- */

    form.addEventListener('submit', function (event) {
      if (window.OdaCart && typeof window.OdaCart.addFromForm === 'function') {
        event.preventDefault();
        /* addFromForm rejette quand /cart/add.js refuse (stock insuffisant,
           variante épuisée). Le message est déjà affiché dans le tiroir : on
           absorbe la promesse pour ne pas laisser une rejection non traitée
           remonter dans la console. */
        var added = window.OdaCart.addFromForm(form);
        if (added && typeof added.catch === 'function') {
          added.catch(function () {});
        }
        return;
      }
      /* Pas de tiroir panier chargé : on laisse le formulaire soumettre
         nativement vers /cart/add, secours sans JavaScript. */
    });
  }

  /* ------------------------------------------------------------------------
     Pop-up "Guide des tailles" ----------------------------------------------
     Calque du pattern .booking-popup Webflow (croix / overlay / Échap, focus
     déplacé et piégé, verrou de scroll), classes .size-popup dédiées. -------
  ------------------------------------------------------------------------ */

  function initSizePopup(root) {
    var scope = root || document;
    var popups = [].slice.call(scope.querySelectorAll('[data-size-popup]'));

    popups.forEach(function (popup) {
      if (popup.dataset.sizePopupBound === '1') return;
      popup.dataset.sizePopupBound = '1';

      var section = popup.closest('.section-boutique') || document;
      var triggers = [].slice.call(section.querySelectorAll('[data-size-popup-trigger]'));
      var closers = [].slice.call(popup.querySelectorAll('[data-size-popup-close]'));
      var lastFocus = null;

      function open(trigger) {
        lastFocus = trigger || document.activeElement;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('size-popup-open');
        var target = popup.querySelector('.size-popup-close') || popup;
        window.setTimeout(function () {
          try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
        }, 40);
      }

      function close() {
        if (!popup.classList.contains('is-open')) return;
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('size-popup-open');
        if (lastFocus && lastFocus.focus) {
          try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
        }
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () { open(trigger); });
      });

      closers.forEach(function (closer) {
        closer.addEventListener('click', function () { close(); });
        closer.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            close();
          }
        });
      });

      popup.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          close();
          return;
        }
        trapTab(event, popup);
      });

      /* Filet au niveau document : si le focus est sorti du panneau (clic sur
         le voile), Échap doit quand même fermer. Garde sur is-open et sur la
         présence du noeud dans le DOM (réinit de l'éditeur de thème). */
      document.addEventListener('keydown', function (event) {
        if ((event.key === 'Escape' || event.key === 'Esc') &&
            document.body.contains(popup) && popup.classList.contains('is-open')) {
          close();
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     Lightbox de la galerie ---------------------------------------------------
     3 photos affichées sur la page, mais la lightbox navigue sur TOUS les
     médias du produit (JSON embarqué). Miniatures, clavier, préchargement. --
  ------------------------------------------------------------------------ */

  function parseGalleryMedia(section) {
    var dataEl = section.querySelector('[data-product-gallery-media]');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function initGallery(root) {
    var scope = root || document;
    var lightboxes = [].slice.call(scope.querySelectorAll('[data-lightbox]'));

    lightboxes.forEach(function (lightbox) {
      if (lightbox.dataset.lightboxBound === '1') return;
      lightbox.dataset.lightboxBound = '1';

      var section = lightbox.closest('.section-boutique') || document;
      var media = parseGalleryMedia(section);
      if (!media.length) return;

      var items = [].slice.call(section.querySelectorAll('[data-gallery-item]'));
      var imageEl = lightbox.querySelector('[data-lightbox-image]');
      var counterEl = lightbox.querySelector('[data-lightbox-counter]');
      var thumbsEl = lightbox.querySelector('[data-lightbox-thumbs]');
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      var closers = [].slice.call(lightbox.querySelectorAll('[data-lightbox-close]'));

      var index = 0;
      var lastFocus = null;
      var thumbEls = [];

      /* Bande de miniatures : construite une seule fois, sur tous les médias. */
      media.forEach(function (item, i) {
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'product-lightbox-thumb';
        thumb.setAttribute('aria-label', 'Voir la photo ' + (i + 1) + ' sur ' + media.length);
        var img = document.createElement('img');
        img.className = 'cover';
        img.src = item.thumb;
        img.alt = item.alt || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        thumb.addEventListener('click', function () { show(i); });
        thumbsEl.appendChild(thumb);
        thumbEls.push(thumb);
      });

      /* Précharge une image voisine pour un passage suivant/précédent fluide. */
      function preload(i) {
        if (i < 0 || i >= media.length) return;
        var img = new Image();
        img.src = media[i].large;
      }

      function show(i) {
        index = (i + media.length) % media.length;
        var current = media[index];
        if (imageEl) {
          imageEl.src = current.large;
          imageEl.alt = current.alt || '';
        }
        if (counterEl) counterEl.textContent = (index + 1) + ' / ' + media.length;
        thumbEls.forEach(function (thumb, n) {
          thumb.classList.toggle('is-active', n === index);
        });
        preload(index + 1 >= media.length ? 0 : index + 1);
        preload(index - 1 < 0 ? media.length - 1 : index - 1);
      }

      function open(startIndex, trigger) {
        lastFocus = trigger || document.activeElement;
        show(startIndex);
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('product-lightbox-open');
        window.setTimeout(function () {
          try { lightbox.focus({ preventScroll: true }); } catch (e) { lightbox.focus(); }
        }, 40);
      }

      function close() {
        if (!lightbox.classList.contains('is-open')) return;
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('product-lightbox-open');
        if (lastFocus && lastFocus.focus) {
          try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
        }
      }

      items.forEach(function (item) {
        var openAt = function () {
          var i = parseInt(item.getAttribute('data-media-index'), 10) || 0;
          open(i, item);
        };
        item.addEventListener('click', openAt);
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            openAt();
          }
        });
      });

      closers.forEach(function (closer) {
        closer.addEventListener('click', function () { close(); });
        closer.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            close();
          }
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

      /* CHANTIER RESPONSIVE D1 (05/09) : swipe tactile sur la scène de la
         lightbox (jusque-là uniquement les flèches). Un seuil de 40px évite
         de confondre un tap ou un léger tremblement avec une intention de
         balayage ; ne remplace ni les flèches ni le clavier, ne touche à
         rien d'autre. */
      var stage = lightbox.querySelector('.product-lightbox-stage');
      if (stage) {
        var touchStartX = null;
        stage.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(dx) < 40) return;
          if (dx < 0) { show(index + 1); } else { show(index - 1); }
        }, { passive: true });
      }

      lightbox.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1);
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1);
          return;
        }
        trapTab(event, lightbox);
      });

      /* Même filet que la pop-up guide : clavier au niveau document quand la
         lightbox est ouverte mais que le focus en est sorti. */
      document.addEventListener('keydown', function (event) {
        if (!document.body.contains(lightbox) || !lightbox.classList.contains('is-open')) return;
        if (event.target && lightbox.contains(event.target)) return;
        if (event.key === 'Escape' || event.key === 'Esc') { close(); return; }
        if (event.key === 'ArrowRight') { show(index + 1); return; }
        if (event.key === 'ArrowLeft') { show(index - 1); }
      });
    });
  }

  /* ------------------------------------------------------------------------
     Amorçage -----------------------------------------------------------------
  ------------------------------------------------------------------------ */

  function initAll(root) {
    var scope = root || document;
    var boxes = [].slice.call(scope.querySelectorAll('[data-buy-box]'));
    boxes.forEach(initBuyBox);
    initSizePopup(scope);
    initGallery(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* L'éditeur de thème remplace la section par un nouveau nœud à chaque
     modification de réglage : on doit ré-acquérir les références. */
  document.addEventListener('shopify:section:load', function (event) {
    var boxes = [].slice.call(event.target.querySelectorAll('[data-buy-box]'));
    boxes.forEach(function (box) { box.dataset.odaProductBound = ''; });
    var popups = [].slice.call(event.target.querySelectorAll('[data-size-popup]'));
    popups.forEach(function (popup) { popup.dataset.sizePopupBound = ''; });
    var lightboxes = [].slice.call(event.target.querySelectorAll('[data-lightbox]'));
    lightboxes.forEach(function (lightbox) { lightbox.dataset.lightboxBound = ''; });
    initAll(event.target);
  });
})();
